import type { FC } from 'react';

import type { ClientDetailPass } from '@/types';
import { TEST_IDS } from '@/testIds';
import { FuturePassRow } from './FuturePassRow';
import styles from './FuturePassesCard.module.css';

interface FuturePassesCardProps {
  passes: ClientDetailPass[];
  onPassClick: (pass: ClientDetailPass) => void;
}

export const FuturePassesCard: FC<FuturePassesCardProps> = ({ passes, onPassClick }) => {
  return (
    <section className={styles.card} data-testid={TEST_IDS.futurePassesSection}>
      {passes.map((pass) => (
        <FuturePassRow key={pass.id} pass={pass} onClick={onPassClick} />
      ))}
    </section>
  );
};
